import{t as o}from"./index-2917df36.js";import"@emotion/css";import{_ as t}from"./index-9623ec8a.js";export default function(r){return t(o(r))}
